<template>
  <div class="navigation d-flex justify-content-between align-items-center w-100">
    <div class="primary-navigation">
      <router-link to="/">
        <img :src="logo" alt="logo" class="logo" />
      </router-link>
      <div class="navigation-list">
        <PrimaryNavigationMenuItem v-for="(item, index) in menu" :key="index" :item="item" :level="0"
          :isParent="true" />
      </div>
    </div>

    <div class="navbar-user" v-if="getUser">
      <template v-if="isLogin && !isStandalonePage">
        <!-- Jira -->
        <template>
          <div class="nav-menu">
            <img v-if="isJiraAuth" src="/images/jira_logo.svg" alt="Jira: logged in" title="Jira: logged in"
              style="width: 24px" />
            <img v-if="!isJiraAuth" src="/images/jira_logo_disabled.svg" alt="Jira: logged out" title="Jira: logged out"
              style="width: 24px" />
          </div>
        </template>
        <!-- Time manager -->
        <!-- <template>
          <div class="nav-menu">
            <img :src="timerIcon" alt="timer" class="header-link-icon" />
          </div>
        </template> -->

        <!-- Notification -->
        <template>
          <b-dropdown class="notification-menu-button " menu-class="notification-block-menu">
            <template v-slot:button-content>
              <div id="users_notifications" variant="link" class="p-0 position-relative notifications nav-menu">
                <span v-html="notificationIconSvg" class="header-link-icon"></span>
                <div class="notification-counter" v-if="unreadNotifications.length">
                  {{ unreadNotifications.length }}
                </div>
              </div>
            </template>

              <div class="d-flex align-item-center justify-content-between">
                <span class="notification-title">Notifications</span>
                <b-button class="button reset-button mark-all-read-button" size="sm" @click="markAllAsRead">
                  Mark all as read
                </b-button>
              </div>

              <b-list-group style="margin-top: 8px;"  v-if="notifications.length">
                <b-list-group-item v-for="({ id, text, is_read }, index) in notifications" :key="index" href="#"
                @click="readNotification(index)" class="notification-item" :class="{ 'is-read': is_read }">
                <span style="padding-right: 20px; display: inline-block; font-size: 14px;">{{
                  text
                }}</span>
                <span class="list-item-el"></span>
              </b-list-group-item>
            </b-list-group>
            <div class="no-notifications" v-else>No notifications</div>
          </b-dropdown>

        </template>

        <!-- Setting -->
        <!-- <template>
          <div class="nav-menu" ref="settingsMenu" style="position: relative">
            <div class="menu-trigger" @click="toggleSubmenu">
              <img
                :src="settingsIcon"
                alt="settings"
                class="header-link-icon"
              />
            </div>
            <div v-show="showSettingsMenu" class="submenu submenu-right">
              <PrimaryNavigationMenuItem
                v-for="(item, index) in settingsMenu"
                :key="index"
                :item="item"
                :level="level + 1"
                dir="left"
                @close-all="() => (showSettingsMenu = false)"
              />
            </div>
          </div>
        </template> -->

        <!-- User block -->
        <template>
          <b-dropdown id="user-menu-button"
            class="user-menu-button dropdown__theme-light navbar__dropdown navbar-details" right variant="link"
            menu-class="user-block-menu" toggle-class="text-decoration-none" no-caret>
            <template v-slot:button-content>
              <div class="navbar-avatar">
                <img v-if="getUser.avatar || getUser.avatar_url" :src="getUser.avatar_url" alt="avatar" />
                <b-img v-else src="/images/avatar-placeholder.png" rounded="circle" class="user-profile-avatar mr-10" />
              </div>
            </template>
            <div class="profile-block-wrapper">
              <div class="d-flex align-items-center" style="padding: 8px">
                <div class="navbar-avatar">
                  <img v-if="getUser.avatar || getUser.avatar_url" :src="getUser.avatar_url" alt="avatar" />
                  <b-img v-else src="/images/avatar-placeholder.png" rounded="circle"
                    class="user-profile-avatar mr-10" />
                </div>
                <div>
                  <div class="user-container">
                    <span class="navbar-user__name">
                      {{ getUser.name }}
                    </span>
                    <span class="navbar-user__position">
                      {{ getUser.position }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <b-dropdown-item-button :href="{ name: 'users' }">
              <router-link class="dropdown-item-link" :to="{ name: 'my-profile' }">
                Profile
              </router-link>
            </b-dropdown-item-button>

            <b-dropdown-item-button>
              <a v-if="isJiraAuth" class="dropdown-item-link" href="javascript:void(0)" @click="logoutFromJira">
                Logout from Jira
              </a>
              <a v-else class="dropdown-item-link" href="javascript:void(0)" @click="logInToJira">
                Login to Jira
              </a>
            </b-dropdown-item-button>
            <b-dropdown-item-button @click="logOut">
              <a href="javascript:void(0)" class="dropdown-item-link router-link-active">
                Log Out
              </a>
            </b-dropdown-item-button>
          </b-dropdown>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/logo_g.svg'
import settingsIcon from '@/assets/settings.svg'
import timerIcon from '@/assets/timer.svg'
import { permissions } from '@mocks/permissions'

import { notificationIconSvg } from '@/assets/icons/notificationIcon'
import PrimaryNavigationMenuItem from './PrimaryNavigationMenuItem.vue'

export default {
  name: 'PrimaryNavigation',
  props: {

    menu: { type: Array, default: () => [] }
  },
  components: {
    PrimaryNavigationMenuItem
  },
  data () {
    return {
      logo,
      settingsIcon,
      timerIcon,
      notificationIconSvg,
      notifications: [],
      fetchNotificationsTimer: null,
      permissions,
      showSettingsMenu: false,
      level: 0,
      settingsMenu: [
        {
          name: 'Organization',
          children: [
            { name: 'Organization details', route: 'home' },
            { name: 'System settings', route: 'home' },
            { name: 'Plan & Billing', route: 'home' }
          ]
        },
        {
          name: 'Business & operations',
          children: [
            { name: 'Legal entities', route: 'home' },
            { name: 'Chart of accounts', route: 'home' },
            { name: 'Financial accounts', route: 'home' },
            { name: 'Tax types', route: 'home' },
            { name: 'Sales channels', route: 'home' },
            { name: 'Specialisation items', route: 'home' }
          ]
        },
        {
          name: 'Holidays & schedule',
          children: [
            { name: 'Holidays', route: 'home' },
            { name: 'Time off settings', route: 'home' }
          ]
        },
        {
          name: 'Personnel & reporting',
          children: [
            { name: 'Skills', route: 'home' },
            { name: 'Permissions table', route: 'home' }
          ]
        },
        {
          name: 'Integrations',
          children: [{ name: 'Integrations - Jira', route: 'home' }]
        }
      ]
    }
  },
  computed: {
    isStandalonePage () {
      const routeName = this.$route.name
      return this.standalonePages.includes(routeName)
    },
    unreadNotifications () {
      return this.notifications.filter((notification) => !notification.is_read)
    },
    shortcutsDropdown () {
      if (
        !this.navbar ||
        !this.navbar.Shortcuts ||
        !this.navbar.Shortcuts.showItem
      ) {
        return null
      }

      const filteredShortcuts = Object.keys(
        this.navbar.Shortcuts.children || {}
      )
        .filter((key) => {
          const child = this.navbar.Shortcuts.children[key]
          return child && child.showItem
        })
        .map((key) => this.navbar.Shortcuts.children[key])

      return {
        ...this.navbar.Shortcuts,
        children: filteredShortcuts
      }
    }
  },

  mounted () {
    this.init()
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    init () {
      if (this.isLogin) {
        this.fetchNotifications()
        const user = this.getUser
        window.Echo.private(`user.${user.id}`).listen(
          '.App\\Notifications\\NewNotification',
          (e) => {
            this.fetchNotifications()
          }
        )
      }
    },
    logoutFromJira () {
      this.axios({
        method: 'get',
        url: '/api/logout-from-jira/',
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      })
        .then((response) => {
          if (response.data === 'OK') {
            this.$snotify.success(
              'You are successfully logged out from Jira ',
              'Success',
              this.$store.state.snotify
            )
            this.setIsJiraAuth(false)
          }
        })
        .catch((err) => {
          this.errorNotifications(err)
        })
    },
    toggleSubmenu (event) {
      this.showSettingsMenu = !this.showSettingsMenu

      this.handleOutsideClick(event)
    },
    handleOutsideClick (event) {
      const menuEl = this.$refs.settingsMenu
      if (menuEl && !menuEl.contains(event.target)) {
        this.showSettingsMenu = false
      }
    },
    async fetchNotifications () {
      const response = await this.axios({
        method: 'get',
        url: '/api/user-notifications',
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      })
      this.notifications = response.data
    },
    readNotification (index) {
      const id = this.notifications[index].id
      this.notifications[index].is_read = true
      this.axios({
        method: 'get',
        url: '/api/user-notifications/read/' + id,
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      })
        .then((response) => {
          window.location.href = response.data.redirect_url
        })
        .catch((err) => {
          this.errorNotifications(err)
        })
    },
    markAllAsRead () {
      this.axios({
        method: 'post',
        url: '/api/user-notifications/read-all/',
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      })
        .then((response) => {
          this.notifications.forEach((notification) => {
            notification.is_read = true
          })
        })
        .catch((err) => {
          this.errorNotifications(err)
        })
    },
    logOut () {
      this.$api.auth.logout()
    }
  }
}
</script>

<style scoped lang="scss">
.nav-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  padding: 2px;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #e4efff;
  }
}

.navigation {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: $bgColorWhite;
  padding: 10px 16px;
}

.primary-navigation {
  display: flex;
  align-items: center;
  width: 100%;
}

.navigation-list {
  margin-left: 24px;
  display: flex;
  align-items: center;
  gap: 30px;
}

.notifications {

  // margin-right: 5px;
  &:focus {
    box-shadow: none;
  }
}

.header-link-icon {
  display: inline-block;
  line-height: 0;
}

::v-deep .header-link-icon>svg {
  width: 24px;
  height: 24px;
}

.navbar-link {
  white-space: nowrap;
  color: $fontColorBase;
  font-size: 15px;
  font-weight: 400;
  text-decoration: none;

  :global(.btn) {
    font-size: inherit;
  }
}

.navbar-link.active {
  font-weight: 700;
  color: $iconColorAccent;
}

::v-deep .dropdown-menu {
  border-radius: 5px;
  box-shadow: 4px 4px 10px 0 rgba(208, 208, 208, 0.3);
  padding: 8px;
}

::v-deep .dropdown-navbar .show {
  padding: 8px;
}

::v-deep .dropdown-menu.user-block-menu {
  width: 240px !important;
  top: 52px !important;
}

::v-deep .user-block-menu {
  width: 240px !important;
  min-width: unset !important;
  padding: 8px !important;
  border: 1px solid #F3F5F7 !important;
}

.navbar-avatar {
  margin: unset;
}

.profile-block-wrapper {
  background-color: #e4efff;
  border-radius: 5px;
}

.dropdown-item-link {
  border-top: 1px solid #e4e7ee;
  width: 100%;
  font-size: 13px !important;
  border-radius: unset !important;
  line-height: 24px !important;
  padding: 8px 4px !important;
}

.dropdown__theme-light .dropdown-menu li {
  padding: unset;
}

.dropdown__theme-light .router-link-exact-active.router-link-active {
  // background-color: #e4e7ee;
  // color: #3d5170;

  background-color: unset;
  color: unset;
}

.mark-all-read-button {
  border: unset;
  background-color: $bgColorWhite;
  font-family: "Ubuntu", sans-serif !important;
  text-transform: unset !important;
  font-weight: 400 !important;
  font-size: 10px !important;
  line-height: 20px !important;
}

.navbar-user {
  gap: 8px;
}

::v-deep .popover-body {
  overflow: auto;
  padding: 8px !important;
  width: 330px;
}

.notification-title {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: $iconColor;
}

::v-deep h3.popover-header {
  padding: 0 !important;
}

::v-deep .popover-header {
  padding: 0 !important;
}

::v-deep .popover .arrow {
  display: none;
}

::v-deep .popover {
  width: 330px !important;

  .arrow {
    display: none !important;
  }
}

.notification-popover {
  min-width: 330px !important;
  width: 330px !important;
  top: 35px !important;
  left: 40px !important;
  border: 1px solid #F3F5F7 !important;
  background-color: $bgColorWhite;
  box-shadow: 4px 4px 10px 0 rgba(208, 208, 208, 0.3);

  .no-notifications {
    padding: 0.5rem 0.75rem;
  }

  .list-group-item {
    border: unset;
    border-radius: 5px;
    padding: 8px;
  }

  .notification-item {
    line-height: 20px;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    font-family: $font-family-sans-serif;
    background-color: #e4efff;
    font-weight: 400 !important;
    position: relative;
    color: $fontColorBase;
    font-size: 14px !important;

    span {
          font-size: 14px !important;

    }

    .list-item-el {
      width: 5px;
      height: 5px;
      border-radius: 100%;
      display: block;
      position: absolute;
      right: 8px;
      top: 8px;
      background-color: $fontColorAccent;
    }
  }

  .notification-item.is-read {
    background-color: #fff;

    .list-item-el {
      display: none;
    }
  }

  .notification-item+.notification-item {
    margin-top: 8px;
  }
}

.notification-counter {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -4px;
  left: 42%;
  white-space: nowrap;
  min-width: 24px;
  height: 14px;
  padding: 0 5px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 0;
  background-color: #2f80ed;
  color: white;
}

.submenu {
  position: absolute;
  min-width: 180px;
  width: max-content;
  background: white;
  border-radius: 5px;
  box-shadow: 4px 4px 10px 0 rgba(208, 208, 208, 0.3);
  z-index: 1000;
  padding: 8px;

  & .navbar-link,
  & .menu-trigger {
    color: $buttonTxtColor2;
    padding: 4px;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
  }
}

.submenu-right {
  right: 0;
  margin-left: 12px;
  top: 100%;
  margin-top: 20px;
}

::v-deep .dropdown-menu.notification-block-menu {
  min-width: 330px !important;
  width: 330px !important;
  top: 48px !important;
  max-height: 350px !important;
  // left: 40px !important;
  overflow: auto;
    border: 1px solid #F3F5F7 !important;
  background-color: $bgColorWhite;
  box-shadow: 4px 4px 10px 0 rgba(208, 208, 208, 0.3);

  .no-notifications {
    padding: 0.5rem 0.75rem;
  }

  .list-group-item {
    border: unset;
    border-radius: 5px;
    padding: 8px;
  }

  .notification-item {
    line-height: 20px;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    font-family: $font-family-sans-serif;
    background-color: #e4efff;
    font-weight: 400 !important;
    position: relative;
    color: $fontColorBase;

    .list-item-el {
      width: 5px;
      height: 5px;
      border-radius: 100%;
      display: block;
      position: absolute;
      right: 8px;
      top: 8px;
      background-color: $fontColorAccent;
    }
  }

  .notification-item.is-read {
    background-color: #fff;

    .list-item-el {
      display: none;
    }
  }

  .notification-item+.notification-item {
    margin-top: 8px;
  }
}

::v-deep .notification-block-menu {
  width: 240px !important;
  min-width: unset !important;
  padding: 8px !important;
  border: 1px solid #F3F5F7 !important;
  right: 0px !important;
  left: unset !important;
}
</style>
